import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import Numeral from 'numeral';

import { BorderRadius, FontSizes, FontWeights } from '../Theme';

const QuoteSimple = ({ quote }) => {
  const styles = {
    component: {
      backgroundColor: '#fff',
      border: '1px solid #e5e5e5',
      borderRadius: BorderRadius.DEFAULT,
      cursor: 'pointer',
      overflow: 'hidden',
      position: 'relative'
    },
    content: {
      padding: 20,
      display: 'flex',
      textAlign: 'inherit',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    company: {
      width: '20%',
      height: 40,
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      textAlign: 'center',
      fontWeight: FontWeights.BOLD
    },
    product_name: {
      fontSize: FontSizes.LARGE,
      fontWeight: FontWeights.BOLD,
      marginBottom: 5
    },
    premium: {
      width: '30%',
      textAlign: 'right'
    },
    premium_total: {
      padding: '5px 0',
      lineHeight: '1em'
    },
    premium_amount: {
      fontWeight: FontWeights.BOLD,
      fontSize: FontSizes.LARGE
    },
    premium_interval: {
      textTransform: 'capitalize'
    },
    product: {
      width: '25%',
      lineHeight: '1.3em',
      marginBottom: 0
    },
    rating: {
      textAlign: 'center',
      fontSize: FontSizes.XLARGE,
      width: '10%'
    },
    rating_date: {
      fontSize: FontSizes.SMALL,
      marginTop: 5
    }
  };

  return (
    <div style={styles.component}>
      <div style={styles.content}>
        <div
          style={Object.assign(
            {},
            styles.company,
            quote.carrier_id
              ? {
                  backgroundImage:
                    'url(https://s3-us-west-2.amazonaws.com/ixn-data/logos/carrier_' +
                    quote.carrier_id +
                    '_medium.png)'
                }
              : null
          )}
        >
          {!quote.carrier_id ? quote.carrier_name : null}
        </div>
        <div style={styles.product}>
          <div style={styles.product_name}>{quote.product_name}</div>(
          {quote.carrier_health_category})
        </div>
        <div style={styles.premium}>
          {['monthly', 'quarterly', 'semi_annual', 'annual'].map(payment_mode => {
            return (
              <div key={payment_mode} style={styles.premium_total}>
                <span style={styles.premium_interval}>{payment_mode.replace('_', ' ')}:</span>{' '}
                <span style={styles.premium_amount}>
                  {Numeral(quote[`premium_${payment_mode}`]).format('$0,0.00')}
                </span>
              </div>
            );
          })}
        </div>
        <div style={styles.rating}>
          {quote.am_best_rating}
          <div style={styles.rating_date}>
            {quote.am_best_date
              ? Moment(quote.am_best_date, 'YYYY-MM-DD').format('MMM Do, YYYY')
              : ''}
          </div>
        </div>
      </div>
    </div>
  );
};

QuoteSimple.propTypes = {
  quote: PropTypes.object.isRequired
};

export default QuoteSimple;
